module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-13-svgrepo-com.54f99c67.svg";